import React from 'react'
import { Script } from 'gatsby'

const Chat = () => {
  return <Script src="//js-na1.hs-scripts.com/22470940.js" />
}

export default Chat
